import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";

import { CustomFieldLookupService } from "./CustomFieldLookupService";
import { PrimaryLookupService } from "../../impl/PrimaryLookupService";
import { ICustomFieldPromiseLookupService } from "../ICustomFieldPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import { CubiqWorker } from "../../../worker/CubiqWorker";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class CustomFieldPrimaryLookupService
  extends PrimaryLookupService<string, CubiqTS.CustomFieldImpl>
  implements ICustomFieldPromiseLookupService
{
  constructor(
    protected base: CustomFieldLookupService,
    protected factory: ServiceMessageBrokerFactory,
    protected cubiqWorker: CubiqWorker,
  ) {
    super(base, factory, CubiqTS.CustomFieldImpl, cubiqWorker, "CustomFieldImpl");

    cubiqWorker.isAuth(`${this.constructor.name}`).then(
      () => {
        let customFieldObservable = cubiqWorker.primeStaticData<CubiqTS.CustomFieldImpl>(
          CubiqTS.CustomFieldImpl.name,
        );

        customFieldObservable.subscribe(
          (customField: CubiqTS.CustomFieldImpl[]) => {
            this.base.prime(customField);
          },
          (error: Error) => {
            console.debug("CustomField prime failed");
            this._primed.reject(error);
          },
          () => {
            this._primed.resolve(true);
          },
        );
      },
      (reason) => {
        console.debug("CustomFieldPrimaryLookupService: Failed to prime: " + reason);

        this._primed.resolve(false);
      },
    );

    this.broker.registerMethod(
      "getCustomField",
      [PRIMITIVE],
      this.getCustomField.bind(this),
      this.VALUE,
    );
    this.broker.registerMethod(
      "getAllCustomFields",
      [],
      this.getAllCustomFields.bind(this),
      this.VALUE,
    );
    this.broker.registerMethod(
      "getActiveCustomFields",
      [],
      this.getActiveCustomFields.bind(this),
      this.VALUE,
    );
    this.broker.registerMethod("isEnabled", [PRIMITIVE], this.isEnabled.bind(this), PRIMITIVE);
    this.broker.registerMethod(
      "getCustomFieldOrdinal",
      [PRIMITIVE],
      this.getCustomFieldOrdinal.bind(this),
      PRIMITIVE,
    );
  }

  getCustomField(fieldName: string): Promise<CubiqTS.CustomFieldImpl> {
    return new Promise<CubiqTS.CustomFieldImpl>((res, rej) => {
      res(this.base.getCustomField(fieldName));
    });
  }

  getCustomFieldOrdinal(field: CubiqTS.CustomFieldImpl): Promise<number> {
    return new Promise<number>((res) => {
      res(this.base.getCustomFieldOrdinal(field));
    });
  }

  getAllCustomFields(): Promise<Array<CubiqTS.CustomFieldImpl>> {
    return new Promise<Array<CubiqTS.CustomFieldImpl>>((res, rej) => {
      res(this.base.getAllCustomFields());
    });
  }

  getActiveCustomFields(): Promise<Array<CubiqTS.CustomFieldImpl>> {
    return new Promise<Array<CubiqTS.CustomFieldImpl>>((res, rej) => {
      res(this.base.getActiveCustomFields());
    });
  }

  isEnabled(fieldName: string): Promise<boolean> {
    return new Promise<boolean>((res) => {
      res(this.base.isEnabled(fieldName));
    });
  }
}
